export default __webpack_public_path__ + "static/media/4-large.17138f63.webp";